import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Button from '../../../shared/components/Button';
import Avatar from '../../../shared/components/Avatar';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import { 
  alphabeticallySort,
  textContains
} from '../../../shared/utils';

class AgencyManageAccoutTeam extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    //TODO: Load data from server for AgencyManageAccoutTeam in componentDidMount
    Promise
      .all([])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  componentWillUnmount(){
    //TODO: Cleanup after AgencyManageAccoutTeam in componentWillUnmount
  }

  render(){
    
    const { users, match, updateUser } = this.props;

    return (
      <div className='AgencyManageAccoutTeam'>
        <Row>
          <Col xs='12'>
            <SearchableDataTable 
              items={users}
              hideSearch
              //HACK: There is an ongoing bug where active isnt sent over the wire for the withChildren call
              isActiveFunc={(u) =>  true || u.active}
              columns={[
                {
                  width:10,
                  renderCell:(item) => (
                    <Avatar
                      userName={item.firstName}
                      imageUrl={item.avatarThumbnailURL}
                    />
                  )
                },
                {
                  display:'name',
                  name:'name',                  
                  width:40,
                  sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                  filterFunc:(a,searchParam) => textContains(a.name,searchParam), 
                  renderCell:(item) => (
                    <Link to={`${match.url}/${item.id}`}>
                      {item.firstName || ''} {item.lastName || ''}
                    </Link>
                  )
                },
                {
                  display:'role',
                  name:'role',                  
                  width:10,
                  sortFunc:(a,b) => b.isOwner - a.isOwner,
                  renderCell:(item) => ( <span>{item.isOwner ? 'Admin' : 'Creator'}</span> )
                },
                {
                  width:40,
                  renderCell:(item) => (
                    <div className='pull-right'>
                      <Button
                        size='sm'
                        linkHref={`${match.url}/${item.id}`}
                        textColor='#666666'
                        borderColor='#cccccc'
                        backgroundColor='#fff'
                      >
                        Edit
                      </Button> 
                      &nbsp;&nbsp;
                      <DropdownButton 
                        options={[
                          {
                            text:item.active ? 'Deactivate' : 'Activate', 
                            onClick:() => updateUser(item.id,{active:!item.active})
                          }
                        ]} 
                      />
                    </div>
                  )                    
                }  
              ]}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

AgencyManageAccoutTeam.propTypes = {
  //TODO: Fill in prop types for AgencyManageAccoutTeam
};

AgencyManageAccoutTeam.defaultProps = {
  //TODO: Fill in defaultProps for AgencyManageAccoutTeam
};

export default AgencyManageAccoutTeam;



// WEBPACK FOOTER //
// ./src/routes/AgencyManageAccoutTeam/components/AgencyManageAccoutTeam.js